(() => {
  const dismissedClass = 'bloxy-cookie-consent-dismissed';
  const storageKey = 'bloxyCookieConsentDismissed';
  const cookieName = 'bloxy_cookie_consent_dismissed';
  const bannerSelector = [
    '#shopify-pc__banner',
    '.shopify-pc__banner',
    '#shopify-pc__banner__dialog',
    '.shopify-pc__banner__dialog',
  ].join(',');
  const buttonSelector = [
    '#shopify-pc__banner button',
    '.shopify-pc__banner button',
    '#shopify-pc__banner__dialog button',
    '.shopify-pc__banner__dialog button',
    '#shopify-pc__banner [role="button"]',
    '.shopify-pc__banner [role="button"]',
    '#shopify-pc__banner__dialog [role="button"]',
    '.shopify-pc__banner__dialog [role="button"]',
  ].join(',');

  const hasCookie = () => document.cookie.split(';').some((item) => item.trim().startsWith(`${cookieName}=`));

  const isDismissed = () => {
    try {
      return window.localStorage.getItem(storageKey) === 'true' || hasCookie();
    } catch (error) {
      return hasCookie();
    }
  };

  const hideBanner = () => {
    document.querySelectorAll(bannerSelector).forEach((banner) => {
      banner.setAttribute('hidden', '');
      banner.setAttribute('aria-hidden', 'true');
      banner.style.setProperty('display', 'none', 'important');
      banner.style.setProperty('visibility', 'hidden', 'important');
      banner.style.setProperty('pointer-events', 'none', 'important');
    });
  };

  const markDismissed = () => {
    document.documentElement.classList.add(dismissedClass);

    try {
      window.localStorage.setItem(storageKey, 'true');
    } catch (error) {
      // Ignore storage restrictions and rely on the cookie fallback.
    }

    document.cookie = `${cookieName}=1; Max-Age=31536000; Path=/; SameSite=Lax`;
    hideBanner();
  };

  const isDismissButton = (button) => {
    const label = `${button.id || ''} ${button.className || ''} ${button.getAttribute('aria-label') || ''} ${
      button.textContent || ''
    }`.toLowerCase();

    return (
      label.includes('accept') ||
      label.includes('confirm') ||
      label.includes('decline') ||
      label.includes('deny') ||
      label.includes('disable') ||
      label.includes('reject') ||
      label.includes('save')
    );
  };

  document.addEventListener(
    'click',
    (event) => {
      const target = event.target instanceof Element ? event.target : event.target.parentElement;
      const button = target?.closest(buttonSelector);
      if (!button || !isDismissButton(button)) return;

      window.setTimeout(markDismissed, 0);
      window.setTimeout(hideBanner, 250);
    },
    true
  );

  if (isDismissed()) {
    document.documentElement.classList.add(dismissedClass);
    hideBanner();
  }

  new MutationObserver(() => {
    if (isDismissed()) hideBanner();
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
